import LoginForm from './LoginForm'
import LoginOrganizationForm from './LoginOrganizationForm'

export {
  LoginForm,
  LoginOrganizationForm
}



// WEBPACK FOOTER //
// ./src/views/Login/components/index.js